export default __webpack_public_path__ + "static/media/image_Quotas_black_gray.a1cf4094.svg";